import { selectionHasMark } from '../helpers/selection';
import { TextSelection } from 'prosemirror-state';
export function createAnchor(state, dispatch) {
  let transaction = state.tr;
  let $cursor = state.selection.$cursor;
  if ($cursor) {
    return false;
  }
  if (!selectionHasMark(state, state.schema.marks.anchor)) {
    transaction = state.tr.addMark(state.selection.from, state.selection.to, state.schema.marks.anchor.create({
      href: ''
    }));
  }
  transaction = transaction.setSelection(TextSelection.create(transaction.doc, state.selection.to - 1));
  if (dispatch) {
    dispatch(transaction.scrollIntoView());
  }
  return true;
}